import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@core/services/http/http.service';
import { HostConfigService } from '@core/services/host-config.service';

export interface RegistrarIngresoResponse {
  rotado: boolean;
}

@Injectable()
export class RegistroIngresoService {
  private readonly http = inject(HttpService);
  private readonly hostConfig = inject(HostConfigService);

  public registrarIngreso(): Observable<RegistrarIngresoResponse> {
    const url = `${this.hostConfig.getCurrentBaseServiceUrl()}autorizacion/registrar-ingreso`;
    return this.http.doPost<object, RegistrarIngresoResponse>(url, {});
  }
}
